<template>
    <div class="billing-main-scroll">
        <button class="billing-detail-back" @click="bs.backToOrders()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
            {{ $t('common.billing.backToOrders') }}
        </button>

        <div class="billing-section-title">{{ $t('common.billing.orderPrefix') }} #{{ order.id }}</div>

        <div class="billing-detail-card">
            <div class="billing-detail-header">
                <span class="billing-detail-name">{{ order.name }}</span>
                <span class="billing-detail-amount">{{ bs.formatPrice(order.amount) }}&#8378;</span>
            </div>
            <div class="billing-detail-meta">
                {{ bs.formatDate(order.date) }} &middot; {{ order.paymentMethod }}
                &middot; <span :class="['billing-order-status', 'billing-status--' + order.status]">{{ $t('common.billing.status_' + order.status) }}</span>
            </div>
        </div>

        <div v-if="transactions.length" class="billing-section-title" style="font-size: 13px;">{{ $t('common.billing.transactions') }}</div>
        <div class="billing-tx-list">
            <div v-for="tx in transactions" :key="tx.id" class="billing-tx-card">
                <div class="billing-tx-header">
                    <span class="billing-tx-id">{{ tx.id }}</span>
                    <span class="billing-tx-date">{{ tx.date }}</span>
                    <span class="billing-tx-method">{{ tx.method }}</span>
                    <span class="billing-tx-amount">{{ bs.formatPrice(tx.amount) }}&#8378;</span>
                </div>
                <div v-if="tx.error" class="billing-tx-error">{{ $t('common.billing.error') }}: {{ tx.error }}</div>
                <div v-if="tx.status === 'failed'" class="billing-tx-actions">
                    <button class="billing-tx-btn billing-tx-btn--cancel">{{ $t('common.billing.cancelOrder') }}</button>
                    <button class="billing-tx-btn billing-tx-btn--retry">{{ $t('common.billing.retry') }}</button>
                </div>
            </div>
        </div>

        <div v-if="!transactions.length" class="billing-empty-state">
            <svg class="billing-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span class="billing-empty-text">{{ $t('common.billing.noTransactions') }}</span>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingOrderDetail',
    computed: {
        bs() {
            return billingService
        },
        order() {
            return billingService.selectedOrder.value || {}
        },
        transactions() {
            return billingService.selectedTransactions.value
        },
    },
}
</script>
